export const ADD_COMPARE_ITEM = 'innovA/compare#addComparedItem';
export const REMOVE_COMPARED_ITEM = 'innovA/compare#removeComparedItem';
export const UPDATE_COMPARE_ITEM = 'innovA/compare#updateCompareItem';
export const UPDATE_COMPARED_LIST = 'innovA/compare#updateComparedItem';

